import { MyListing } from '../container/listing';
import { MyProfile } from '../container/my-profile';
import { MyRentals } from '../container/my-rentals';
import { MyWallet } from '../container/my-wallet';
import { ReferAFriend } from '../container/refer';
// import { Settings } from '../container/settings';
import { PATHS } from './path';

const menus = [
  {
    id: 'my_profile',
    label: 'My Profile',
    to: PATHS.profile,
    component: MyProfile,
  },
  {
    id: 'my_wallet',
    label: 'My Wallet',
    to: PATHS.wallet,
    component: MyWallet,
  },
  {
    id: 'my_closet',
    label: 'My Closet',
    to: PATHS.rentals,
    component: MyRentals,
  },
  {
    id: 'my_listings',
    label: 'My Listings',
    to: PATHS.listings,
    component: MyListing,
  },
  {
    id: 'order_histroy',
    label: 'Order History',
    to: PATHS.orderHistory,
    target: '_parent',
  },
  {
    id: 'refer_a_friend',
    label: 'Refer A Friend',
    to: PATHS.refer,
    component: ReferAFriend,
  },
  // {
  //   id: "settings",
  //   label: "Settings",
  //   to: PATHS.settings,
  //   component: Settings,
  // },
];

export default menus;
